import pharmacy from 'services/pharmacy';

export const useInDeliveryRange = () => {
  return (odscode, postcode) => pharmacy.get(`/pharmacies/${odscode}/in-delivery-range-of/${postcode}`);
};

export const useInDeliveryRangeDirect = () => {
  return (odscode, postcode) =>
    pharmacy.get(`/pharmacies/${odscode}/in-delivery-range-of/${postcode}`, { params: { direct_delivery: true } });
};
